import { useInitializeContactBusinessEvents } from './hooks'

interface ContactBusinessEventsInitializationProps {
  contactId: string
}

export const ContactBusinessEventsInitialization: React.FC<ContactBusinessEventsInitializationProps> = ({ contactId }) => {
  useInitializeContactBusinessEvents(contactId)

  return null
}
